import React from "react";
import ModalCreateClient from "./ModalCreateClient";
import Button from "../../atoms/Button";
import Modal from "../../molecules/Modal";
import useModal from "../../../hooks/useModal";
import { FaUserPlus } from "react-icons/fa";

const CreateClient = ({ refetch }) => {
    const { open, close, isOpen } = useModal();

    return(
        <div>
            <Button text={<FaUserPlus size={22} />} bgColor="green" onClick={open} width="w-10" />
            {isOpen && 
                <Modal title="Crear cliente" onClose={close}>
                    <ModalCreateClient onClose={close} refetch={refetch} />
                </Modal>
            }
        </div>
    );
};

export default CreateClient;